export const ROLES = {
    ADMIN: "admin",
    BOARD: "board",
    EXEC: "exec",
    SALES: "sales",
    CLIENT: "client",
};
export const ALL_ROLES = Object.values(ROLES);
//# sourceMappingURL=roles.js.map